export default "__VITE_ASSET__BiMnW7L3__"